/** Экран полномочий: ответы ручек `/api/permissions`. */
import { apiFetch } from "@/lib/api";

export type PermissionInfo = { code: string; label: string; hint: string };
export type PermissionUser = {
  id: number;
  name: string | null;
  short: string | null;
  /** ISO с `Z`; `null` — держатель права, который в prokat не входил. */
  last_login: string | null;
  codes: string[];
};
export type PermissionsAnswer = { permissions: PermissionInfo[]; users: PermissionUser[] };

export function loadPermissions(): Promise<PermissionsAnswer> {
  return apiFetch<PermissionsAnswer>("/api/permissions");
}

export function setPermission(userId: number, code: string, on: boolean): Promise<{ user_id: number; codes: string[] }> {
  return apiFetch<{ user_id: number; codes: string[] }>(`/api/permissions/${userId}/${encodeURIComponent(code)}`, {
    method: on ? "PUT" : "DELETE",
  });
}
